import Div from '@ui/layout/Div'
import { useTranslation } from 'react-i18next'

const useRenderTableScans = () => {
  const [t] = useTranslation('common')

  const numbersToShorts = {
    1: '1st',
    2: '2nd',
    3: '3rd'
  }

  const numbersToString = {
    1: 'firstScan',
    2: 'secondScan',
    3: 'thirdScan'
  }

  const numbersToScan = {
    1: 'isFirstScanned',
    2: 'isSecondScanned',
    3: 'isThirdScanned'
  }
  const renderMissionSubjectsStat = (id, missionSubjectsStat, mission) => {
    if (mission.missionSubjects.length > 1) {
      return mission.missionSubjects.map(missionSubject => {
        return (
          <h5 key={`${id}-${missionSubject.label}-stat`}>
            <span>{missionSubject.label}</span>: {missionSubjectsStat[missionSubject.label] || 0}
          </h5>
        )
      })
    }
  }

  const getStats = (missionSubjectConfig, scansData, scanNB) => {
    if (missionSubjectConfig.withEggs) {
      return <>
        <h5><span>{1 == scanNB ? t('table.found_nests') : t('table.new_found_nests')}</span> :{scansData[numbersToString[scanNB]].totalUnits}</h5>
        <h5><span>{1 == scanNB ? t('table.empty_nests') : t('table.new_empty_nests')}</span> :{scansData[numbersToString[scanNB]].totalEmptyUnits}</h5>
        <h5><span>{1 == scanNB ? t('table.nb_eggs') : t('table.new_nb_eggs')}</span> :{scansData[numbersToString[scanNB]].totalEggs}</h5>
        <h5><span>{1 == scanNB ? t('table.nb_non_treated_eggs') : t('table.new_nb_non_treated_eggs')}</span> :{scansData[numbersToString[scanNB]].totalNonTreatedEggs}</h5>
        <h5><span>{1 == scanNB ? t('table.nb_birds') : t('table.new_nb_birds')}</span> :{scansData[numbersToString[scanNB]].totalBirds}</h5>
      </>
    } else {
      return <>
        <h5><span>{t('table.found')}</span> :{scansData[numbersToString[scanNB]].totalUnits}</h5>
        <h5><span>{t('table.nb_treated')}</span> :{scansData[numbersToString[scanNB]].totalTreated}</h5>
        <h5><span>{t('table.nb_non_treated')}</span> :{scansData[numbersToString[scanNB]].totalNonTreated}</h5>
      </>
    }
  }

  const renderScans = (nbScans, scansHolder, mission) => {
    const missionSubjectConfig = mission.missionSubjects[0].config
    let scans = []
    for (let i = 1; i <= nbScans; i++) {
      const scan = scansHolder.scansData[numbersToScan[i]]
        ? <Div cssClass='column'>
          <h4>{t(`table.${numbersToShorts[i]}_scan`)}</h4>
          {getStats(missionSubjectConfig, scansHolder.scansData, i)}
          {renderMissionSubjectsStat(scansHolder.id, scansHolder.scansData[numbersToString[i]].missionSubjects, mission)}
        </Div>
        : <Div cssClass='column'>
          <h4>{t(`table.${numbersToShorts[i]}_scan`)}</h4>
          <h5>{t('table.pending')}</h5>
        </Div>
      scans.push(scan)
    }

    return scans
  }

  return renderScans
}

export default useRenderTableScans